<!-- 설비 유형 상세 (EquipTypeDetail) -->
<template>
    <div v-if="status" class="detail-container" ref="detailContainer">
        <DetailHeader
            :currentNode="currentNode"
            :systemName="systemName"
            :equipName="equipName"
            :nodeTypeValue="nodeTypeValue"
            :nodeInfo="nodeInfo"
            :sumNodeTotal="sumNodeTotal"
            :phscPointUsageMap="phscPointUsageMap"
            :filterSystemType="filterSystemType"
            @save-point-click="handleSavePointClick"
        >
            <template #controls>
                <DetailHeaderControls
                    :expanded="expanded"
                    :queryType="queryType"
                    :statusDate="statusDate"
                    :isRefresh="isRefresh"
                    @change-expanded-tree="changeExpandedTree"
                    @change-query-date="changeQueryDate"
                    @change-date="handleDateChange"
                    @prev-day="prevDay"
                    @next-day="nextDay"
                    @interval-refresh="intervalRefresh"
                    @export-pdf="exportPdf"
                />
            </template>
        </DetailHeader>
        <!-- 영향 인자 PANEL -->
        <div
            v-if="!isEmpty(status.relatedPointStatus)"
            block
            v-b-toggle.rltdPoints
            class="accordion-title"
            style="padding: 3px 10px !important"
        >
            <div class="d-flex">
                <div>
                    <span v-if="rltdPoints">
                        <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    </span>
                    <span v-if="!rltdPoints">
                        <i class="fa fa-chevron-up" aria-hidden="true"></i>
                    </span>
                    <span class="ml-2">영향 인자</span>
                </div>
            </div>
            <span
                class="status-icon"
                style="cursor: pointer"
                @click="showRltdStatusDetail($event)"
                v-b-tooltip.hover
                :title="$t('영향 인자 상세보기')"
            >
                <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
            </span>
        </div>
        <b-collapse
            v-if="!isEmpty(status.relatedPointStatus)"
            v-model="rltdPoints"
            ref="rltdPoints"
            id="rltdPoints"
            class="collapse-body detail-itemview"
        >
            <RltdPointsPanel :status="status" @selectRltdPoint="handleSelectRltdPoint" />
        </b-collapse>

        <!-- 제어 타임라인 PANEL -->
        <div
            v-if="!isEmpty(status.ctrlTimeline)"
            block
            v-b-toggle.timeline
            class="accordion-title"
            style="padding: 3px 10px !important; height: 42px !important"
        >
            <div class="d-flex">
                <div class="mr-2">
                    <span v-if="timeline">
                        <i class="fa fa-chevron-down" aria-hidden="true"></i>
                    </span>
                    <span v-if="!timeline">
                        <i class="fa fa-chevron-up" aria-hidden="true"></i>
                    </span>
                </div>
                <span>제어 타임라인</span>
            </div>
        </div>
        <div v-if="!isEmpty(status.ctrlTimeline)" ref="timeline" id="timeline" class="collapse-body detail-itemview">
            <div
                ref="timelineContainer"
                v-if="currentNode"
                class="timelineContainer col-md-12 p-0 d-flex justify-content-center"
            >
                <div
                    style="
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0px 10px 0px 10px;
                        cursor: pointer;
                    "
                    @click="prevDay"
                >
                    <span style="font-size: 1.5rem">
                        <i class="fas fa-angle-left" aria-hidden="true"></i>
                    </span>
                </div>
                <TImeLinePanel :currentNode="currentNode" :events="events" :statusDate="statusDate" />
                <div
                    style="
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0px 10px 0px 10px;
                        cursor: pointer;
                    "
                    @click="nextDay"
                >
                    <span style="font-size: 1.5rem"><i class="fas fa-angle-right" aria-hidden="true"></i></span>
                </div>
            </div>
        </div>

        <!-- 운전현황 헤더 영역 -->
        <OperationStatusHeader
            :opStatus="opStatus"
            :functionMode="functionMode"
            :activeIcon="activeIcon"
            :filterSystemType="filterSystemType"
            :currentNode="currentNode"
            :rltdTrendData="rltdTrendData"
            :selectedRltdPtIdx="selectedRltdPtIdx"
            :showChartSaveButton="showChartSaveButton"
            :isRltdPoint="isRltdPoint"
            :dragMode="dragMode"
            :isIgnoreZero="isIgnoreZero"
            :ctrlMode="ctrlMode"
            :queryType="queryType"
            @set-chart-order="setChartOrder"
            @open-table-view-select="openTableViewSelect"
            @show-rltd-point-trend="showRltdPointTrend"
            @toggle-drag-mode="toggleDragMode"
            @set-chart-view="setChartView"
            @change-ignore-zero="changeIgnoreZero"
            @set-org-data="setOrgData"
            @icon-click="handleIconClick"
            @handle-database-modal="handleDatabaseModal"
            @handle-ctrl-modal="handleCtrlModal"
            @unit-equip-control="unitEquipControl"
            @selected-rltd-pt-idx-change="handleSelectedRltdPtIdxChange"
        />

        <!-- 운전현황 컨텐츠 영역 -->
        <b-collapse
            visible
            ref="opStatus"
            id="externalStateMenu"
            class="collapse-body detail-itemview opStatus"
            style="padding: 0.5rem; overflow-y: auto; overflow-x: hidden"
        >
            <TableView
                v-if="activeIcon == 'tableView'"
                :filterSystemType="filterSystemType"
                :currentNode="currentNode"
                :summary="summary"
                :columns="columns"
                :rows="rows"
                :transCodes="transCodes"
                :engGaugeData="engGaugeData"
                :engDoughnutData="engDoughnutData"
                :engGaugeDatas="engGaugeDatas"
                @button-click="unitCtrlModal"
                ref="TableView"
            />
            <TileView
                v-else-if="activeIcon == 'tileView'"
                :tails="tails"
                :ctrlMode="ctrlMode"
                @button-click="unitCtrlModal"
            />
            <OrgChartView
                v-else-if="activeIcon == 'org-chart'"
                :energyMap="energyMap"
                :queryType="queryType"
                :statusDate="statusDate"
                :zoomAndPositionStyle="zoomAndPositionStyle"
                @start-drag="startDrag"
                @on-drag="onDrag"
                @stop-drag="stopDrag"
                @handle-scroll="handleScroll"
                @reset-zoom="resetZoom"
                @open-point-detail="openPointDetail"
                @close-point-detail="closePointDetail"
                ref="OrgChartView"
            />
            <FlowChartView
                v-else-if="activeIcon === 'flow-chart'"
                :sumNodeFlowData="sumNodeFlow"
                :phscPointUsageMap="phscPointUsageMap"
            />
            <PatternChartView
                v-else-if="activeIcon === 'pattern-chart'"
                :sumNodeTrend="sumNodeTrend"
                :isSumNodeTrend="isSumNodeTrend"
                :currentNode="currentNode"
                :rltdTrendData="rltdTrendData"
                :selectedRltdPtIdx="selectedRltdPtIdx"
                :queryType="queryType"
                :predictData="predictData"
                :sumNodeHourly="sumNodeHourly"
                :sumNodeDaily="sumNodeDaily"
                :sumNodeTotal="sumNodeTotal"
            />
            <ScatterChartView
                v-else-if="activeIcon === 'scatter-chart'"
                :sumNodeTrend="sumNodeTrend"
                :isSumNodeTrend="isSumNodeTrend"
                :currentNode="currentNode"
                :rltdTrendData="rltdTrendData"
                :selectedRltdPtIdx="selectedRltdPtIdx"
                :queryType="queryType"
                :predictData="predictData"
                :baseChartData="baseChartData"
                :regressionResult="regressionResult"
            />

            <StackChartView
                v-else-if="activeIcon === 'stack-chart'"
                :sumNodeTrend="sumNodeTrend"
                :isSumNodeTrend="isSumNodeTrend"
                :currentNode="currentNode"
                :rltdTrendData="rltdTrendData"
                :selectedRltdPtIdx="selectedRltdPtIdx"
                :queryType="queryType"
                :predictData="predictData"
                :baseChartData="baseChartData"
            />
            <EquipChartView
                v-else-if="activeIcon === 'equip-chart' || activeIcon === 'prop-chart'"
                :responseChart="responseChart"
                :isChartLoading="isChartLoading"
                :dragMode="dragMode"
                :chartColumn="chartColumn"
                :isDragging="isDragging"
                :dragIndex="dragIndex"
                @update-chart-order="updateChartOrder"
                @on-drag-start="onDragStart"
                @on-drag-end="onDragEnd"
                @click-mix-chart="clickMixChart"
            />
        </b-collapse>
        <EquipControlModal
            v-if="equipData"
            :ctrlType="ctrlType"
            :equipData="equipData"
            :currentNode="currentNode"
            @equip-control="equipControl"
            @clear-data="clearData"
            ref="EquipControl"
        />
        <RltdStatusModal
            v-if="rltdLiveStatus"
            ref="RltdStatusModal"
            :statusDetail="rltdLiveStatus"
            :currentNode="currentNode"
            :statusDate="statusDate"
            @reload="getEquipStatus(currentNode, statusDate)"
            @clear-data="clearRltdLiveStatus"
        />
        <b-modal centered ref="tableViewSelectModal" size="sm" @hidden="closeTableViewSelect">
            <template #modal-header>
                <h5 class="mb-0">표시 속성</h5>
            </template>
            <template #modal-footer>
                <div style="display: flex; flex: 1">
                    <button
                        type="button"
                        class="btn btn-primary ctrl-modal-btn"
                        @click="filterColumns(currentNode, statusDate)"
                    >
                        적용
                    </button>
                    <button type="button" class="btn btn-secondary ctrl-modal-btn" @click="closeTableViewSelect">
                        닫기
                    </button>
                </div>
            </template>
            <div class="mb-2">
                <span>차트에 표시될 설비 속성을 선택하세요.</span>
            </div>
            <div class="form-group">
                <div class="form-check mb-2">
                    <input
                        v-model="allCheck"
                        type="checkbox"
                        class="form-check-input"
                        id="all"
                        @click="allCheckChartView"
                    />
                    <label class="form-check-label" for="all">전체 선택</label>
                </div>
            </div>
            <div v-if="chartView" class="table-view-container">
                <div class="form-group">
                    <div v-for="(list, index) in chartView" :key="index" class="form-check mb-2">
                        <input
                            v-model="chartView[index].checked"
                            type="checkbox"
                            class="form-check-input"
                            :id="index"
                            @change="changeChartViewStatus"
                        />
                        <label class="form-check-label" :for="index">{{ list.value }}</label>
                    </div>
                </div>
            </div>
        </b-modal>

        <DatabaseModalPanel
            v-if="routerType === 'energy'"
            :flag="databaseModalFlag"
            :data="sumNodeTotal"
            @closeDataBaseModal="handleDatabaseModal(false)"
            :title="currentNode.text"
        ></DatabaseModalPanel>
        <equip-database-modal-panel
            v-if="routerType === 'equip'"
            :flag="databaseModalFlag"
            @closeDataBaseModal="handleDatabaseModal(false)"
            :currentNode="currentNode"
            :statusDate="statusDate"
            :baseChartData="baseChartData"
            :queryType="queryType"
        ></equip-database-modal-panel>
        <b-sidebar
            v-model="isSideBarShow"
            ref="ptInfoDetail"
            id="ptInfoDetail"
            bg-variant="light"
            backdrop-variant="secondary"
            @hidden="closePointDetail"
            width="33vw"
            no-header
            shadow
            right
            backdrop
        >
            <div style="height: 100%" class="pt-info-detail">
                <PointInfoDetail
                    v-if="isPointDetail"
                    ref="point-info-detail"
                    :title="''"
                    :ptIdx="ptDetailIdx"
                    :noWatch="true"
                    @closed="closePointDetail"
                />
            </div>
        </b-sidebar>
        <SavePointModal ref="savePointModal" :nodeInfo="nodeInfo" @save="saveSysNode" />
    </div>
</template>

<script>
import moment from "moment";
import backEndApi from "@src/api/backEndApi";
import EquipControlModal from "./modal/EquipControlModal.vue";
import RltdStatusModal from "./modal/RltdStatusModal.vue";
import RltdPointsPanel from "./panel/RltdPointsPanel.vue";
import TImeLinePanel from "./panel/TImeLinePanel.vue";
import summaryGaugeChartData from "./charts/summaryGaugeChartData";
import gaugeChartData from "./charts/gaugeChartData";
import DatabaseModalPanel from "./panel/DatabaseModalPanel.vue";
import PointInfoDetail from "@src/views/new/point-management/point-mgmt/PointDetail.vue";
import * as popupMessages from "@src/consts/popupMessageConsts";
import EquipDatabaseModalPanel from "./panel/EquipDatabaseModalPanel.vue";
import SavePointModal from "./modal/SavePointModal.vue";
import html2pdf from "html2pdf.js";
import DetailHeader from "./components/DetailHeader.vue";
import DetailHeaderControls from "./components/DetailHeaderControls.vue";
import OperationStatusHeader from "./components/OperationStatusHeader.vue";
import TableView from "./components/view-modes/TableView.vue";
import TileView from "./components/view-modes/TileView.vue";
import OrgChartView from "./components/view-modes/OrgChartView.vue";
import FlowChartView from "./components/view-modes/FlowChartView.vue";
import PatternChartView from "./components/view-modes/PatternChartView.vue";
import ScatterChartView from "./components/view-modes/ScatterChartView.vue";
import StackChartView from "./components/view-modes/StackChartView.vue";
import EquipChartView from "./components/view-modes/EquipChartView.vue";
import StatusDataMixin from "./mixins/StatusDataMixin.js";
import ChartDataMixin from "./mixins/ChartDataMixin.js";
import TableDataMixin from "./mixins/TableDataMixin.js";

export default {
    mixins: [StatusDataMixin, ChartDataMixin, TableDataMixin],
    components: {
        PointInfoDetail,
        EquipControlModal,
        RltdStatusModal,
        RltdPointsPanel,
        TImeLinePanel,
        // CompareChartPanel,
        DatabaseModalPanel,
        // StatisticalAnalysisPanel
        EquipDatabaseModalPanel,
        SavePointModal,
        DetailHeader,
        DetailHeaderControls,
        OperationStatusHeader,
        TableView,
        TileView,
        OrgChartView,
        FlowChartView,
        PatternChartView,
        ScatterChartView,
        StackChartView,
        EquipChartView,
    },
    props: ["data", "currentNode", "expanded"],
    async created() {
        this.getSystemType();
        this.getEquipType();
        /**물리관제점 용도코드를 가져옵니다. */
        this.getphscPointUsage();
        this.setRouterType();
    },
    async mounted() {
        if (this.$refs.OrgChartView?.getOrgChartPanel()) {
            const container = this.$refs.OrgChartView.getOrgChartPanel();
            container.addEventListener("wheel", this.handleScroll);
        }
    },
    beforDestroyed() {
        const container = this.$refs.OrgChartView?.getOrgChartPanel();
        container.removeEventListener("wheel", this.handleScroll);
    },
    data() {
        return {
            routerType: null,
            databaseModalFlag: false,
            zoomLevel: 1, // 초기 배율
            maxZoom: 3, // 최대 배율
            minZoom: 0.3, // 최소 배율
            dragging: false, // 드래그 상태
            dragStart: { x: 0, y: 0 }, // 드래그 시작 위치
            position: { x: 0, y: 0 }, // 현재 위치
            transCodes: [
                {
                    field: "nodeType",
                    codes: this.$store.state.commonCodes.nodeType,
                },
                {
                    field: "equipType",
                    codes: this.$store.state.transEquipType,
                },
                {
                    field: "unitType",
                    codes: this.$store.state.unitTypes,
                },
                {
                    field: "sumUnit",
                    codes: this.$store.state.units,
                },
                {
                    field: "zoneIdx",
                    codes: this.$store.state.zoneInfo,
                },
                {
                    field: "equipUseType",
                    codes: this.$store.state.commonCodes.phscPointUsage,
                },
            ],
            ptDetailIdx: null,
            isSideBarShow: false,
            isPointDetail: false,
            rows: [],
            tails: [],
            columns: [],
            handleColumns: [], // TableDataMixin에서 사용
            handleRowData: null,
            ctrlType: null,
            equipData: null,
            checks: null,

            status: null,
            events: [],
            statusDate: moment(new Date()).format("YYYY-MM-DD"),

            // 운전현황 패널 표시 관련
            functionMode: "",
            activeIcon: "tableView",

            isRefresh: false,
            interval: null,
            today: moment(new Date()).format("YYYY-MM-DD"),

            baseChartData: null,

            viewColumn: "1",

            systemName: null,
            equipName: null,
            equipTypeDetail: null,

            rltdLiveStatus: null,
            rltdTrendData: null,
            isRltdPoint: false,

            chartView: [],

            dragIndex: null,
            isDragging: false,
            dragMode: false,

            rltdPoints: false,
            timeline: false,

            opStatus: false,

            allCheck: true,
            ctrlMode: null,

            equipStatusData: null,
            queryType: "NOW",

            isIgnoreZero: true,

            summary: null,

            engGaugeData: null,
            engDoughnutData: null,
            engGaugeDatas: null,

            selectedRltdPtIdx: null,

            sumNodeTotal: null,

            /** 물리관제점 용도 코드배열, 물리관제점 용도 코드 map객체 */
            phscPointUsageArr: null, // StatusDataMixin에서 사용
            phscPointUsageMap: null,

            // 시간 패턴 차트 origin data
            originHourly: null,

            // 회기 분석 데이터
            regressionResult: null,

            // 트렌드 예측값 비교
            predictData: [],

            // 트랜드 1형, 2형 chart loading
            isChartLoading: false,
            popupMessages,

            // 소팅된 프롭코드 저장 (ChartDataMixin에서 사용)
            sortedPropsArr: null,

            // old 프롭코드 순서
            originalOrder: [],

            // 프롭 코드순서가 바뀌었는지 판단
            isOrderChanged: false,

            // 선택한 노드 상세 정보, 저장 관제점 관리를 위함
            nodeInfo: null,
        };
    },
    computed: {
        showChartSaveButton() {
            return this.activeIcon === "prop-chart" && this.isOrderChanged;
        },
        zoomAndPositionStyle() {
            return {
                transform: `scale(${this.zoomLevel}) translate(${this.position.x}px, ${this.position.y}px)`,
                transformOrigin: "center",
                transition: this.dragging ? "none" : "transform 0.2s ease",
            };
        },
        sumNodeTrend() {
            return !this.isEmpty(this.sumNodeTotal) ? this.sumNodeTotal.trendData : null;
        },
        isSumNodeTrend() {
            const check = this.sumNodeTotal.trendData.results.some((result) =>
                Object.keys(result).some((key) => {
                    let isNull;
                    if (key !== "regDt") isNull = result[key] !== null;
                    return isNull;
                })
            );
            return check;
        },
        sumNodeDaily() {
            return !this.isEmpty(this.sumNodeTotal) ? this.sumNodeTotal.dailyPattern : null;
        },
        sumNodeHourly() {
            return !this.isEmpty(this.originHourly) ? this.originHourly : null;
        },
        sumNodeFlow() {
            return !this.isEmpty(this.status.energyFlow) ? this.status.energyFlow : null;
        },
        chartColumn() {
            return this.viewColumn == "1" ? "col-md-11" : this.viewColumn == "2" ? "col-md-6" : "col-md-4";
        },
        nodeTypeValue() {
            const nodeType = this.currentNode.nodeType;
            return this.$store.state.commonCodes.nodeType.find((item) => item.value == nodeType).text ?? "-";
        },
        responseChart: {
            get() {
                return this.baseChartData ? this.baseChartData : [];
            },
            set() {},
        },
        filterSystemType() {
            return this.$store.state.systemTypeList.find((type) => type.sysType == this.currentNode.sysType);
        },
        // 에너지 맵 데이터 초기화 없이 반응형으로 데이터 감시
        energyMap() {
            return this.equipStatusData ? this.equipStatusData : null;
        },
    },
    watch: {
        selectedRltdPtIdx(newVal) {
            if (this.activeIcon == "scatter-chart") this.setRegressionData(newVal);
        },
        currentNode: {
            immediate: true,
            async handler(newVal) {
                await this.initSetting(newVal);
            },
        },
    },
    methods: {
        clickMixChart(ptIdx) {
            let ptIdxNum = Number(ptIdx);
            if (!ptIdxNum) return;
            this.openPointDetail(ptIdxNum);
        },
        async initSetting(newVal) {
            this.originHourly = null;
            this.selectedRltdPtIdx = null;

            this.getSystemType(newVal);
            this.getEquipType(newVal);

            this.getSysNode(newVal.sysNodeIdx);
            await this.getEquipTypeDetail(newVal);
            await this.getEquipStatus(newVal, this.statusDate);

            if (Array.isArray(this.status.relatedPointStatus)) {
                this.rltdPoints = this.status.relatedPointStatus.length > 0 ? true : false;
            } else {
                this.rltdPoints = false;
            }

            if (Array.isArray(this.status.ctrlTimeline)) {
                this.timeline = this.status.ctrlTimeline.length > 0 ? true : false;
            } else {
                this.timeline = false;
            }
            this.opStatus = true;
            this.$nextTick(() => {
                this.fitToCenter();
            });
        },
        handleSavePointClick() {
            if (this.$refs.savePointModal) {
                this.$refs.savePointModal.showSavePointModal();
            }
        },
        async handleDateChange(date) {
            this.statusDate = date;
            // 현재 활성화된 view mode에 맞는 데이터를 다시 불러옴
            await this.refreshCurrentViewData();
        },
        /**
         * 날짜 변경 시 현재 활성화된 view mode에 맞는 데이터를 다시 불러오는 메서드
         */
        async refreshCurrentViewData() {
            if (!this.activeIcon) return;

            // 각 view mode에 따라 필요한 데이터만 선택적으로 불러오기
            if (this.activeIcon == "tableView" || this.activeIcon == "tileView") {
                // tableView, tileView는 기본 상태 데이터만 필요
                await this.getEquipStatus(this.currentNode, this.statusDate);
                return;
            } else if (this.activeIcon == "org-chart") {
                // org-chart는 별도 API 호출 필요
                let result;
                let statusParams = {
                    sysNodeIdx: this.currentNode.sysNodeIdx,
                    queryDate: this.statusDate,
                    queryType: this.queryType,
                    ignoreZero: this.isIgnoreZero ? "Y" : "",
                };
                try {
                    if (this.currentNode.nodeType !== "Equip") {
                        result = await backEndApi.sysNode.getSystemOprtStatus(statusParams);
                    } else {
                        result = await backEndApi.sysNode.getEquipOprtStatus(statusParams);
                    }
                    if (result.status == 200) {
                        this.equipStatusData = result.data.equipStatus;
                        this.$nextTick(() => {
                            this.fitToCenter();
                        });
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                    }
                } catch (e) {
                    console.error(e);
                }
                return;
            }

            // 나머지 view mode들은 공통으로 getEquipStatus가 필요
            // getEquipStatus 내부에서 sumAvail == "Y"일 때 getSumNodeTrendAll을 호출함
            await this.getEquipStatus(this.currentNode, this.statusDate);

            // 각 view mode별 추가 데이터 로딩
            // 주의: getEquipStatus 내부에서 sumAvail == "Y"일 때 이미 getSumNodeTrendAll 호출됨
            if (this.activeIcon == "equip-chart") {
                if (this.filterSystemType.sumAvail !== "Y") {
                    await this.getGroupTrendData(this.currentNode, this.statusDate);
                } else {
                    // 이미 getEquipStatus에서 getSumNodeTrendAll 호출됨
                    this.sumNodeFormatChartDatas();
                }
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);
                if (this.isRltdPoint) await this.showRltdPointTrend(null, true);
            } else if (this.activeIcon == "prop-chart") {
                await this.getTrendDataByProp(this.currentNode, this.statusDate);
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);
                if (this.isRltdPoint) await this.showRltdPointTrend(null, true);
            } else if (this.activeIcon == "scatter-chart") {
                // getEquipStatus에서 sumAvail == "Y"일 때 이미 getSumNodeTrendAll 호출됨
                // sumAvail != "Y"인 경우에만 추가로 호출 필요
                if (this.filterSystemType.sumAvail !== "Y") {
                    await this.getSumNodeTrendAll(this.currentNode, this.statusDate);
                }
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);
                await this.setRegressionData(this.selectedRltdPtIdx);
                if (this.sumNodeTotal?.trendData) {
                    this.sumNodeFormatChartDatas();
                }
            } else if (this.activeIcon == "stack-chart") {
                // getEquipStatus에서 sumAvail == "Y"일 때 이미 getSumNodeTrendAll 호출됨
                // sumAvail != "Y"인 경우에만 추가로 호출 필요
                if (this.filterSystemType.sumAvail !== "Y") {
                    await this.getSumNodeTrendAll(this.currentNode, this.statusDate);
                }
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);
                if (this.currentNode.nodeType == "Equip") {
                    this.sumNodeFormatChartDatasForEquip();
                } else {
                    this.sumNodeFormatChartDatas();
                }
            } else if (this.activeIcon == "flow-chart") {
                // flow-chart는 getEquipStatus에서 energyFlow 데이터를 가져옴
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);
            } else if (this.activeIcon == "pattern-chart") {
                this.originHourly = null;
                // getEquipStatus에서 sumAvail == "Y"일 때 이미 getSumNodeTrendAll 호출됨
                // sumAvail != "Y"인 경우에만 추가로 호출 필요
                if (this.filterSystemType.sumAvail !== "Y") {
                    await this.getSumNodeTrendAll(this.currentNode, this.statusDate);
                }
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);

                let searchParams = {
                    sysNodeIdx: this.currentNode.sysNodeIdx,
                    queryType: "HOURLY_PATTERN",
                    queryDate: this.statusDate,
                };
                try {
                    let result = await backEndApi.sysNode.getSumNodePatternData(searchParams);
                    if (result.status == 200) {
                        this.originHourly = result.data;
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                    }
                } catch (e) {
                    console.error(e);
                }

                this.sumNodeFormatChartDatas();
            }
        },
        async saveSysNode(data) {
            if (this.isEmpty(data)) {
                this.alertWarning("저장 관제점 데이터를 확인해주세요.");
                return;
            } else {
                this.nodeInfo.savePtAddr = data.ptAddr;
                this.nodeInfo.savePtIdx = data.ptIdx;

                await this.$emit("save-sys-node", this.nodeInfo);

                this.$refs.savePointModal.hideSavePointModal();
            }
        },

        setRouterType() {
            if (this.$route.params.type) {
                this.routerType = this.$route.params.type;
            }
        },
        closePointDetail() {
            this.$refs.ptInfoDetail.hide();
            this.isSideBarShow = false;
            this.isPointDetail = false;
        },
        openPointDetail(ptIdx) {
            if (ptIdx) {
                this.ptDetailIdx = ptIdx;
                this.isSideBarShow = true;
                this.isPointDetail = true;
            } else return;
        },
        fitToCenter() {
            this.$nextTick(() => {
                const container = this.$refs.OrgChartView?.$refs?.orgChartContainer;
                const panel = this.$refs.OrgChartView?.getOrgChartPanel()?.$el;
                if (!container || !panel) return;

                // 초기화
                panel.style.transform = "";
                panel.style.transformOrigin = "center center";

                // 컨테이너와 패널 크기 측정
                const containerWidth = container.offsetWidth;
                const containerHeight = container.offsetHeight;
                const panelWidth = panel.scrollWidth;
                const panelHeight = panel.scrollHeight;

                // 패널을 컨테이너의 정중앙으로 이동
                this.position = {
                    x: (containerWidth - panelWidth) / 2,
                    y: (containerHeight - panelHeight) / 2,
                };

                // 최종 transform 적용
                panel.style.transform = `translate(${this.position.x}px, ${this.position.y}px)`;
            });
        },
        async handleDatabaseModal(flag) {
            this.databaseModalFlag = flag;
        },
        resetZoom() {
            const button = this.$refs.zoomResetButton;

            button.style.transform = "rotate(0deg)";
            button.style.transition = "none";

            setTimeout(() => {
                button.style.transition = "transform 0.5s ease";
                button.style.transform = "rotate(360deg)";
            });

            this.zoomLevel = 1;
            this.position = { x: 0, y: 0 };
        },

        handleScroll(event) {
            if (event.deltaY < 0 && this.zoomLevel < this.maxZoom) {
                this.zoomLevel += 0.1; // 줌 인
            } else if (event.deltaY > 0 && this.zoomLevel > this.minZoom) {
                this.zoomLevel -= 0.1; // 줌 아웃
            }
        },
        startDrag(event) {
            this.dragging = true;
            this.dragStart = {
                x: event.clientX - this.position.x,
                y: event.clientY - this.position.y,
            };
        },
        onDrag(event) {
            if (!this.dragging) return;
            this.position = {
                x: event.clientX - this.dragStart.x,
                y: event.clientY - this.dragStart.y,
            };
        },
        stopDrag() {
            this.dragging = false;
        },

        async setOrgData(type, event) {
            if (this.$refs.OrgChartView?.getOrgChartPanel()) {
                this.$refs.OrgChartView.getOrgChartPanel().formatData(type);
            }
            if (event) await event.stopPropagation();
        },
        async changeExpandedTree() {
            await this.$emit("setExpandedTree");
            if (this.filterSystemType.sumAvail == "Y") await this.getEquipStatus(this.currentNode, this.statusDate);
        },
        async changeQueryDate(queryDate) {
            if (queryDate == "NOW") {
                this.queryType = queryDate;
                this.statusDate = moment(new Date()).format("YYYY-MM-DD");
                await this.refreshCurrentViewData();
            } else if (queryDate == "DAY") {
                this.queryType = queryDate;
                this.statusDate = moment(new Date()).format("YYYY-MM-DD");
                await this.refreshCurrentViewData();
            } else if (queryDate == "MONTH") {
                this.queryType = queryDate;
                this.statusDate = moment(new Date()).format("YYYY-MM");
                await this.refreshCurrentViewData();
            } else return;
        },

        async unitEquipControl(event) {
            await event.stopPropagation();
            const tableComponent =
                this.activeIcon === "tableView" && this.$refs.TableView
                    ? this.$refs.TableView.getTableListComponent()
                    : null;
            if (!tableComponent) return;

            let value = await tableComponent.getSelectProperty().filter((item) => item.ioType !== "In");
            let ctrlData = [];

            value.forEach((item) => {
                if (item.selectProp) {
                    ctrlData.push({
                        propCode: item.propCode,
                        ptVal: item.selectProp,
                    });
                }
            });

            let ctrlCmd = {
                equipIdx: this.currentNode.equipIdx,
                ctrlMode: "Basic",
                propList: ctrlData.map((item) => {
                    return {
                        propCode: item.propCode,
                        ptVal: item.ptVal ? item.ptVal : null,
                    };
                }),
            };
            try {
                let result = await backEndApi.equips.sendEquipCtrlCmd(ctrlCmd);
                if (result.status == 200) {
                    await this.alertNoti(popupMessages.SYSTEM_EQUIP_CONTROL_SUCCESS_MESSAGE);
                    setTimeout(async () => {
                        await this.getEquipStatus(this.currentNode);
                    }, 1000);
                } else {
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
        async toggleDragMode(event) {
            await event.stopPropagation();
            this.dragMode = !this.dragMode;
        },
        async changeIgnoreZero(event) {
            await event.stopPropagation();
            this.isIgnoreZero = !this.isIgnoreZero;
            await this.handleIconClick("org-chart");
        },
        changeChartViewStatus() {
            let status = this.chartView.every((item) => item.checked);
            this.allCheck = status ? true : false;
        },
        allCheckChartView() {
            this.allCheck = !this.allCheck;
            if (this.allCheck) {
                this.chartView.forEach((item) => {
                    item.checked = true;
                });
            } else {
                this.chartView.forEach((item) => {
                    item.checked = false;
                });
            }
        },
        async showRltdStatusDetail(event) {
            await event.stopPropagation();
            await this.getRelatedPointStatus(this.currentNode);
            await this.$refs.RltdStatusModal.showStatusDetailModal();
        },
        clearRltdLiveStatus() {
            this.rltdLiveStatus = null;
        },
        sortedProps(equipTypeDetail) {
            const combinedProps = [
                ...(equipTypeDetail.ioProps || []),
                ...(equipTypeDetail.calcProps || []),
                ...(equipTypeDetail.userProps || []),
            ];

            const sortedProp = combinedProps
                .filter((prop) => prop.enabled === "Y")
                .sort((a, b) => a.dispOrder - b.dispOrder)
                .map((prop) => prop.propCode);

            this.sortedPropsArr = [...sortedProp];
        },
        async setChartView(number, event) {
            this.viewColumn = number;
            await event.stopPropagation();
        },
        async getEquipStatus(node, date) {
            this.engGaugeData = null;
            this.engDoughnutData = null;
            this.engGaugeDatas = null;

            let result;

            // this.filterSystemType.sumAvail == 'N'

            let statusParams = {
                sysNodeIdx: node.sysNodeIdx,
                queryDate: date ? date : this.today,
                queryType: this.queryType ? this.queryType : "NOW",
                maxDepth: 1,
                ignoreZero: "Y",
            };

            if (this.filterSystemType.sumAvail == "Y") {
                if (this.filterSystemType.sysType == "ENGSRC") statusParams.targetField = "zoneIdx";
                else statusParams.targetField = "engUseType";
            }

            try {
                if (node.nodeType == "Group") {
                    result = await backEndApi.sysNode.getGroupOprtStatus(statusParams);
                } else if (node.nodeType == "System" || node.nodeType == "Root") {
                    this.equipTypeDetail = [];
                    result = await backEndApi.sysNode.getSystemOprtStatus(statusParams);

                    /**
                     * 여러 설비 유형을 담기 위한 로직이나 아직 미완성이라 추후 수정해서 적용 예정
                     */
                    // if (this.filterSystemType.sumAvail == 'N') {
                    //     const equipTypeArr = Object.keys(result.data.equipStatus).map(key => result.data.equipStatus[key].equipType)
                    //     const promises = equipTypeArr.map(async (item) => {
                    //         try {
                    //             const equipType = await backEndApi.equipTypes.getEquipType(item, "Y");
                    //             if (equipType.status == 200) return equipType.data;
                    //         } catch (e) {
                    //             console.error(e)
                    //         }
                    //     })
                    //     const details = await Promise.all(promises);
                    //     this.equipTypeDetail = details;
                    // }
                } else {
                    result = await backEndApi.sysNode.getEquipOprtStatus(statusParams);
                }

                // API 결과 조회된 equipStatus는 일단 저장하고 활용한다. by badblock
                if (result.data && result.data.equipStatus) {
                    this.equipStatusData = result.data.equipStatus;
                }

                if (result.status == 200) {
                    this.status = result.data;

                    if (result.data.ctrlTimeline && Array.isArray(result.data.ctrlTimeline)) {
                        this.events = result.data.ctrlTimeline.map((item) => {
                            // isPast : item.history 객체 유무로 판단 가능
                            // timeline event icon :
                            // fa-user-plus : Man
                            // fa-history: Schd (with no-repeat)
                            // loop : Schd (with repeat)

                            // set event Icon Type :
                            let eventIcon = "fa-user-plus"; // Default: Manual
                            if (item.ctrlType == "Schd") eventIcon = "fa-history";
                            if (item.plan && item.plan.repeatType != "None") eventIcon = "fa-redo";

                            return {
                                ...item,
                                eventIcon,
                            };
                        });
                    }

                    // equipStatus가 Array가 아니면 Array로 변환하면 처리에 용의하나
                    // 후위 코드에 오류가 있어 적용하지는 않는다.
                    // if (!Array.isArray(result.data.equipStatus)) {
                    //     const equipStatus = { ...result.data.equipStatus };
                    //     result.data.equipStatus = [];
                    //     result.data.equipStatus.push(equipStatus);
                    // }

                    if (result.data.equipStatus && Array.isArray(result.data.equipStatus)) {
                        if (this.currentNode.nodeType == "System") {
                            console.log("system");
                        }
                    }

                    if (this.filterSystemType.sumAvail == "N") {
                        if (!this.isEmpty(result.data.summary)) {
                            this.summary = summaryGaugeChartData.setSummaryGuageData(
                                result.data.summary,
                                this.$store.state.units
                            );
                        } else {
                            const equip = result.data.equipStatus;
                            let summaryData = _makeEquipSummary(equip);
                            let filerSummaryData = summaryData.filter((item) => item.ptVal !== null);
                            this.summary = summaryGaugeChartData.setSummaryGuageData(
                                filerSummaryData,
                                this.$store.state.units
                            );
                        }
                    } else {
                        const equipStatus = result.data.equipStatus;
                        this.engGaugeData = {
                            text: equipStatus[0].text,
                            sumVal: equipStatus[0].sumVal,
                            sumUnit: equipStatus[0].sumUnit,
                            sumRatio: equipStatus[0].sumRatio,
                        };
                        this.engDoughnutData = equipStatus[0].children.map((item) => {
                            return {
                                value: item.sumVal ? item.sumVal : item.ptVal,
                                name: item.text,
                                unit: item.sumUnit ? item.sumUnit : item.unit,
                            };
                        });
                        const baseGauges = equipStatus[0].children
                            .sort((a, b) => (b.sumVal ?? b.ptVal) - (a.sumVal ?? a.ptVal))
                            .map((item) => {
                                return {
                                    text: item.text,
                                    sumVal: item.sumVal ? item.sumVal : item.ptVal ? item.ptVal : 0,
                                    sumUnit: item.sumUnit ? item.sumUnit : item.unit,
                                };
                            });
                        this.engGaugeDatas = gaugeChartData.setGaugeData(baseGauges);
                    }

                    await this.setupTable(result.data.equipStatus);
                    this.setChartDataView(result.data.equipStatus);
                } else {
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
            }

            if (this.filterSystemType.sumAvail == "Y") {
                await this.getSumNodeTrendAll(this.currentNode, this.statusDate);
            }

            await this.handleIconClick(this.activeIcon);

            // Inner Function by badblock
            function _makeEquipSummary(equip) {
                let summary = [];
                let ioProps = [];
                let calcProps = [];
                let userProps = [];
                if (equip.length > 0 && Array.isArray(equip)) {
                    ioProps = equip[0].ioProps.filter((prop) => prop.representSumYn === "Y").map((prop) => prop);
                    calcProps = equip[0].calcProps.filter((prop) => prop.representSumYn === "Y").map((prop) => prop);
                    userProps = equip[0].userProps.filter((prop) => prop.representSumYn === "Y").map((prop) => prop);
                }

                summary = [...ioProps, ...calcProps, ...userProps];
                return summary;
            }
        },

        handleSelectRltdPoint(ptIdx) {
            this.selectedRltdPtIdx = ptIdx;
        },
        handleSelectedRltdPtIdxChange(newVal) {
            this.selectedRltdPtIdx = newVal;
            if (this.activeIcon == "scatter-chart") this.setRegressionData(newVal);
        },
        async openTableViewSelect(event) {
            await event.stopPropagation();
            this.$refs.tableViewSelectModal.show();
        },
        closeTableViewSelect() {
            this.$refs.tableViewSelectModal.hide();
        },

        async equipControl(data, property, value, mode, delayMin) {
            if (this.ctrlType === "Unit") {
                let find = this.handleRowData.find((item) => item.equipIdx === data.equipIdx);
                let ctrlCmd = {
                    equipIdx: find.equipIdx,
                    ctrlMode: mode,
                    delayInMin: delayMin,
                    propList: property.map((item, index) => {
                        return {
                            propCode: item.propCode,
                            ptVal: value[index] ? Number(value[index]) : 0,
                        };
                    }),
                };
                try {
                    let result = await backEndApi.equips.sendEquipCtrlCmd(ctrlCmd);
                    if (result.status == 200) {
                        await this.alertNoti(popupMessages.SYSTEM_EQUIP_CONTROL_SUCCESS_MESSAGE);
                        // await this.setupTable(this.data);
                        setTimeout(async () => {
                            await this.getEquipStatus(this.currentNode, this.statusDate);
                        }, 1000);
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                    }
                } catch (e) {
                    console.error(e);
                }
            } else if (this.ctrlType === "Select") {
                let equipIdxs = data.map((item) => item.equipIdx);
                let ctrlCmd = {
                    equipIdxs,
                    ctrlMode: mode,
                    delayInMin: delayMin,
                    propList: property.map((item, index) => {
                        return {
                            propCode: item.propCode,
                            ptVal: value[index] ? Number(value[index]) : 0,
                        };
                    }),
                };
                try {
                    let result = await backEndApi.equips.sendMultiCtrlCmd(ctrlCmd);
                    if (result.status == 200) {
                        await this.alertNoti(popupMessages.SYSTEM_EQUIP_CONTROL_SUCCESS_MESSAGE);
                        // await this.setupTable(this.data);
                        setTimeout(async () => {
                            await this.getEquipStatus(this.currentNode, this.statusDate);
                        }, 1000);
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                    }
                } catch (e) {
                    console.error(e);
                }
            } else if (this.ctrlType === "Group") {
                let ctrlCmd = {
                    sysNodeIdx: this.currentNode.sysNodeIdx,
                    equipType: data[0].equipType,
                    ctrlMode: mode,
                    delayInMin: delayMin,
                    expandSearch: "Y",
                    propList: property.map((item, index) => {
                        return {
                            propCode: item.propCode,
                            ptVal: value[index] ? Number(value[index]) : 0,
                        };
                    }),
                };
                try {
                    let result = await backEndApi.sysNode.sendGroupCtrlCmd(ctrlCmd);
                    if (result.status == 200) {
                        await this.alertNoti(popupMessages.SYSTEM_EQUIP_CONTROL_SUCCESS_MESSAGE);
                        // await this.setupTable(this.data);
                        setTimeout(async () => {
                            await this.getEquipStatus(this.currentNode, this.statusDate);
                        }, 1000);
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                    }
                } catch (e) {
                    console.error(e);
                }
            } else return;
        },

        async handleCtrlModal(type, event) {
            await event.stopPropagation();
            await this.openCtrlModal(type);
        },

        async openCtrlModal(type) {
            this.ctrlType = type;
            this.equipData = null;

            if (type === "Select") {
                if (this.activeIcon === "tableView" && this.$refs.TableView) {
                    this.checks = this.$refs.TableView.getCheckedRows();
                } else {
                    this.checks = [];
                }
                // this.checks = this.rows.filter(item => item.checked);
                if (this.checks.length < 1) {
                    this.alertNoti(popupMessages.SYSTEM_EQUIP_CONTROL_SELECT_NOTI_MESSAGE);
                    return;
                }
                let find = this.handleRowData.filter((item) =>
                    this.checks.some((check) => check.equipIdx === item.equipIdx)
                );
                this.equipData = find;
                this.$nextTick(() => {
                    this.$refs.EquipControl.showControlModal();
                });
            } else if (type === "Group") {
                try {
                    let result = await backEndApi.sysNode.getIncludedEquipStatus(
                        this.currentNode.sysNodeIdx,
                        this.currentNode.equipType
                    );
                    if (result.status == 200) {
                        this.equipData = result.data;
                        this.$nextTick(() => {
                            this.$refs.EquipControl.showControlModal();
                        });
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                    }
                } catch (e) {
                    console.error(e);
                }
            } else {
                return;
            }
        },
        intervalRefresh() {
            this.isRefresh = !this.isRefresh;

            if (this.isRefresh) {
                this.interval = setInterval(() => this.getEquipStatus(this.currentNode, this.statusDate), 10000);
            } else {
                clearInterval(this.interval);
                this.interval = null;
            }
        },
        async handleIconClick(icon, event) {
            // this.equipStatusData = null;
            this.activeIcon = icon;

            if (event) await event.stopPropagation();

            if (this.activeIcon !== "scatter-chart") {
                ((this.regressionResult = null), (this.predictData = []));
            }

            if (this.activeIcon == "equip-chart") {
                this.baseChartData = [];
                this.isChartLoading = false;
                this.functionMode = "트랜드1형";

                if (this.filterSystemType.sumAvail !== "Y") {
                    await this.getGroupTrendData(this.currentNode, this.statusDate);
                } else {
                    this.sumNodeFormatChartDatas();
                }

                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);
                if (this.isRltdPoint) await this.showRltdPointTrend(null, true);
            } else if (this.activeIcon == "prop-chart") {
                this.functionMode = "트랜드2형";
                this.baseChartData = [];
                this.isChartLoading = false;

                await this.getTrendDataByProp(this.currentNode, this.statusDate);
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);

                if (this.isRltdPoint) await this.showRltdPointTrend(null, true);
            } else if (this.activeIcon == "scatter-chart") {
                this.functionMode = "상관 분석";
                this.baseChartData = [];
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);

                await this.setRegressionData(this.selectedRltdPtIdx);

                if (this.sumNodeTotal.trendData) await this.sumNodeFormatChartDatas();
            } else if (this.activeIcon == "stack-chart") {
                this.baseChartData = [];
                this.functionMode = "성분 분석";
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);

                if (this.currentNode.nodeType == "Equip") {
                    this.sumNodeFormatChartDatasForEquip();
                } else {
                    this.sumNodeFormatChartDatas();
                }
            } else if (this.activeIcon == "org-chart") {
                this.functionMode = "구성 분석";

                let result;
                let statusParams = {
                    sysNodeIdx: this.currentNode.sysNodeIdx,
                    queryDate: this.statusDate,
                    queryType: this.queryType,
                    ignoreZero: this.isIgnoreZero ? "Y" : "",
                };
                try {
                    if (this.currentNode.nodeType !== "Equip")
                        result = await backEndApi.sysNode.getSystemOprtStatus(statusParams);
                    else result = await backEndApi.sysNode.getEquipOprtStatus(statusParams);
                    if (result.status == 200) {
                        this.equipStatusData = result.data.equipStatus;
                        this.$nextTick(() => {
                            this.fitToCenter();
                        });
                    } else {
                        this.alertWarning(
                            `${result.data.message}`,
                            "",
                            `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                        );
                    }
                } catch (e) {
                    console.error(e);
                }
            } else if (this.activeIcon == "flow-chart") {
                this.functionMode = "흐름 분석";
                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);
            } else if (this.activeIcon == "pattern-chart") {
                this.functionMode = "패턴 분석";

                await this.getRelatedPointTrendData(this.currentNode, this.statusDate);
                // await this.setRegressionData(this.selectedRltdPtIdx);

                if (this.isEmpty(this.originHourly)) {
                    let searchParams = {
                        sysNodeIdx: this.currentNode.sysNodeIdx,
                        queryType: "HOURLY_PATTERN",
                        queryDate: this.statusDate,
                    };
                    try {
                        let result = await backEndApi.sysNode.getSumNodePatternData(searchParams);
                        if (result.status == 200) this.originHourly = result.data;
                        else {
                            this.alertWarning(
                                `${result.data.message}`,
                                "",
                                `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                            );
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }

                this.sumNodeFormatChartDatas();
            } else if (this.activeIcon == "tableView") {
                this.functionMode = "일반 현황";
            }
        },

        async prevDay() {
            const date = new Date(this.statusDate);
            if (this.activeIcon == "pattern-chart") this.originHourly = null;
            if (this.queryType == "NOW" || this.queryType == "DAY") {
                date.setDate(date.getDate() - 1);
                this.statusDate = moment(date).format("YYYY-MM-DD");
            } else if (this.queryType == "MONTH") {
                date.setMonth(date.getMonth() - 1);
                this.statusDate = moment(date).format("YYYY-MM");
            } else return;

            // 현재 활성화된 view mode에 맞는 데이터를 다시 불러옴
            await this.refreshCurrentViewData();
        },
        async nextDay() {
            const date = new Date(this.statusDate);
            if (this.activeIcon == "pattern-chart") this.originHourly = null;
            if (this.queryType == "NOW" || this.queryType == "DAY") {
                date.setDate(date.getDate() + 1);
                this.statusDate = moment(date).format("YYYY-MM-DD");
            } else if (this.queryType == "MONTH") {
                date.setMonth(date.getMonth() + 1);
                this.statusDate = moment(date).format("YYYY-MM");
            } else return;

            // 현재 활성화된 view mode에 맞는 데이터를 다시 불러옴
            await this.refreshCurrentViewData();
        },
        unitCtrlModal(data) {
            if (!this.ctrlMode) return;
            this.equipData = null;
            let find = this.handleRowData.find((item) => item.equipIdx === data.equipIdx);
            this.equipData = find;
            this.ctrlType = "Unit";

            this.$nextTick(() => {
                this.$refs.EquipControl.showControlModal();
            });
        },

        clearData() {
            this.equipData = null;
        },
        onDragStart(event) {
            this.dragIndex = event.oldIndex;
            this.isDragging = true;

            // 현재 순서의 key만 저장
            this.originalOrder = this.baseChartData.map((item) => item.key);
        },
        onDragEnd() {
            this.isDragging = false;
            this.dragIndex = null;

            const currentOrder = this.baseChartData.map((item) => item.key);
            this.isOrderChanged = JSON.stringify(currentOrder) !== JSON.stringify(this.originalOrder);
        },
        async exportPdf() {
            const element = this.$refs.detailContainer;
            if (!element) return;

            // PDF 생성 전에 헤더 버튼 영역 숨기기
            const headerButtons = element.querySelector(".detail-header .col-sm-5");
            if (headerButtons) {
                headerButtons.style.display = "none";
            }

            // 스크롤 영역의 원래 높이와 overflow 저장
            const opStatusElement = element.querySelector(".opStatus");
            let originalHeight = "";
            let originalOverflow = "";
            if (opStatusElement) {
                originalHeight = opStatusElement.style.height;
                originalOverflow = opStatusElement.style.overflow;
                // 스크롤 컨텐츠 전체가 보이도록 높이 자동 조정
                opStatusElement.style.height = "auto";
                opStatusElement.style.overflow = "visible";
            }

            // 렌더링 완료를 위해 잠시 대기
            await this.$nextTick();
            await new Promise((resolve) => setTimeout(resolve, 100));

            // 현재 노드명과 날짜로 파일명 생성
            const nodeName = this.currentNode?.text || "설비현황";
            const date = moment(this.statusDate).format("YYYY-MM-DD");

            // 콘텐츠 크기에 맞게 PDF 크기 계산 (px to mm, 1px ≈ 0.264583mm)
            const pxToMm = 0.264583;
            const contentWidth = element.scrollWidth * pxToMm;
            const contentHeight = element.scrollHeight * pxToMm;
            const margin = 10;

            // PDF 크기 계산
            const pdfWidth = contentWidth + margin * 2;
            const pdfHeight = contentHeight + margin * 2;

            // 가로 방향 강제: 가로(width)가 세로(height)보다 크도록 설정
            const finalWidth = Math.max(pdfWidth, pdfHeight);
            const finalHeight = Math.min(pdfWidth, pdfHeight);

            const opt = {
                margin: margin,
                filename: `${nodeName}_${date}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    scrollY: 0,
                    scrollX: 0,
                    windowHeight: element.scrollHeight,
                    windowWidth: element.scrollWidth,
                },
                jsPDF: {
                    unit: "mm",
                    format: [finalWidth, finalHeight], // [가로, 세로] - 가로가 더 큼
                    orientation: "l", // 'l' = landscape
                },
            };

            try {
                await html2pdf().set(opt).from(element).save();
            } finally {
                // PDF 생성 완료 후 원래 상태로 복원
                if (headerButtons) {
                    headerButtons.style.display = "flex";
                }
                if (opStatusElement) {
                    opStatusElement.style.height = originalHeight;
                    opStatusElement.style.overflow = originalOverflow;
                }
            }
        },
    },
};
</script>

<style scoped>
.detail-container {
    padding: 1rem 2rem 1rem 2rem;
    height: 100%;
    width: 100%;
    border-radius: 10px;
    background-color: white;
    font-size: 12px;
    overflow-y: auto;
}

.accordion-title {
    background-color: #ececec;
    padding: 10px;
    margin-bottom: 0px !important;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    border: solid #ececec 1px;
    border-radius: 6px 6px 0px 0px;
}

.detail-itemview {
    width: 100%;
    justify-content: center;
    align-items: center;
    border: solid #ececec 1px;
    border-radius: 0px 0px 6px 6px;
}

.status-icon {
    color: #555;
    background-color: #fff;
    border: solid #bbb 1px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.2rem;
    transition: background-color 0.5s;
    width: 2rem;
    height: 2rem;
}

.status-icon:hover {
    background-color: #c7c7c7;
}

.status-icon.active {
    color: #fff;
    background-color: #555;
}

.table-view-container {
    padding: 1rem;
    border-radius: 10px;
    border: solid #eee 1px;
}

.timelineContainer {
    user-select: none;
    width: 100%;
    height: 16rem;
}

.opStatus {
    user-select: none;
}

.ctrl-modal-btn {
    flex: 1;
    margin: 0px 5px 0px 5px;
}

.p-timeline .p-timeline-event-marker {
    background-color: #ff0000 !important;
}
</style>
